export default __webpack_public_path__ + "static/logo-social-media-3a2e5257eec48790d073aca432c19414.jpg";